import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Tooltip, Select } from 'antd'

import styles from './index.module.css'
import { actionCreators } from '../../store'
import { filterSearchInfo } from '../../../../utils'

import menuSearchIcon from '../../../../statics/menu_search_icon.png'
import searchInfoItemIcon from '../../../../statics/search_info_item_icon.png'
import arrowImg from '../../../../statics/header_personal_arrow.png'


class ChatMessageHeader extends Component {
    constructor(props) {
        super(props)
        // 初始化 state
        this.state = {
            isFocused: false,
            isMouseEnter: false,
        }
    }

    switchItem(active_date, active_topicid) {
        if (this.props.active_date !== active_date || this.props.active_topicid !== active_topicid) {
            this.props.handleSwitchItemAction(active_date, active_topicid)
        }
        this.setState({ isFocused: false, isMouseEnter: false, })
    }

    gobackPersonalOverview() {
        this.props.handleIsShowScreenPersonalOverview(true)
        this.props.handleIsShowScreenStoneModelMall(false)
        this.props.handleIsShowScreenPersonalBackpack(false)
        this.props.handleExpertRelatedAction()
    }

    render() {
        let all_chat_data = this.props.all_chat_data.toJS()
        let chat_count_data = this.props.chat_count_data.toJS()
        let menu_search_content = this.props.menu_search_content.trim()
        let list = filterSearchInfo(all_chat_data)
        let search_list = list.filter(item =>
            menu_search_content && item.conversation_name.includes(menu_search_content)
        );
        let left_unit = null
        if (this.props.is_show_screen_personal_backpack) {
            left_unit = (
                <div
                    className={styles.personal_back}
                    onClick={this.gobackPersonalOverview.bind(this)}
                >
                    <img src={arrowImg} className={styles.personal_back_img} alt="arrow" />
                    返回我的灵石
                </div>
            )
        }

        return (
            <div className={styles.container}>
                <div className={styles.left}>
                    {
                        left_unit
                    }
                </div>

                {/* {
                    this.props.is_show_screen_personal_overview ||
                    this.props.is_show_screen_stone_model_mall ||
                    this.props.is_show_screen_personal_backpack ||
                    (this.props.active_date === '' && this.props.active_topicid === '') ? null : (
                        <div className={styles.middle}>
                            <div className={styles.middle_text_box}>
                                <span>今日对话次数</span>
                                <span className={styles.middle_text_num}>{chat_count_data.current_count} / {chat_count_data.max_count}</span>
                            </div>
                        </div>
                    )
                } */}

                <div className={`${styles.right} ${this.props.is_show_block_usage ? styles.fade_in : ''}`}>
                    <div
                        className={styles.search_box}
                    >
                        <input
                            type={"text"}
                            placeholder={'搜索'}
                            className={styles.search}
                            onChange={this.onSearchChange.bind(this)}
                            value={this.props.menu_search_content}
                            onFocus={() => { this.setState({ isFocused: true }) }}
                            onBlur={() => { this.setState({ isFocused: false }) }}
                        />
                        <img src={menuSearchIcon} className={styles.search_icon} />
                        <div
                            className={styles.search_box_mask}
                        >
                        </div>
                        {
                            this.state.isFocused || this.state.isMouseEnter ? (
                                <div
                                    className={styles.search_info}
                                    onMouseEnter={() => { this.setState({ isMouseEnter: true })}}
                                    onMouseLeave={() => { this.setState({ isMouseEnter: false })}}
                                >
                                    <div className={styles.search_info_header}>历史记录</div>
                                    {
                                        search_list.map((item) => {
                                            return (
                                                <div className={styles.search_info_item} key={item.id}>
                                                    <div
                                                        className={styles.search_info_item_box}
                                                        onClick={() => { this.switchItem(item.date, item.topic_id) }}
                                                    >
                                                        <img src={searchInfoItemIcon} className={styles.search_info_item_icon} />
                                                        <div className={styles.search_info_item_name}>
                                                            { item.conversation_name }
                                                        </div>
                                                    </div>
                                                    <div className={styles.search_info_item_line}></div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            ) : null
                        }
                    </div>

                    <Tooltip placement="bottom" title={"反馈"}>
                        <div
                            className={styles.img_box}
                            onClick={this.handleFeedbackModal.bind(this)}
                        >
                            <div
                                className={`${styles.img} ${styles.feedback_img}`}
                                data-alt="反馈"
                            >
                            </div>
                            <div className={styles.search_box_mask}>
                            </div>
                        </div>
                    </Tooltip>

                    <Tooltip placement="bottom" title={"收藏"}>
                        <div
                            className={styles.img_box}
                            onClick={this.handleGoToCollection.bind(this)}
                        >
                            <div className={`${styles.img} ${styles.collect_img}`} data-alt="收藏"></div>
                            <div className={styles.search_box_mask}></div>
                        </div>
                    </Tooltip>

                    <Tooltip placement="bottom" title={"设置"}>
                        <div
                            className={styles.img_box}
                            onClick={this.handleUserInfoSetting.bind(this)}
                        >
                            <div className={`${styles.img} ${styles.setting_img}`} data-alt="设置"></div>
                            <div className={styles.search_box_mask}></div>
                        </div>
                    </Tooltip>
                </div>
            </div>
        );
    }

    onSearchChange(e) {
        let value = e.target.value
        this.props.handleMenuSearchContentAction(value)
    }

    handleFeedbackModal() {
        this.props.handleIsFeedbackModalOpenAction(true)
    }

    handleGoToCollection() {
        this.props.history.push({ pathname: "/collect" })

        // 使用 HashRouter 时，URL 应该包括 '#'
        // const route = '/collect';
        // const url = window.location.origin + '/#' + route;
        // const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        // if (newWindow) newWindow.opener = null;
    }

    handleUserInfoSetting() {
        this.props.handleUserinfoModalOpenAction()
    }
}

const mapStateToProps = (state) => {
    return {
        menu_search_content: state.get('home').get('menu_search_content'),
        is_show_block_usage: state.get('home').get('is_show_block_usage'),
        all_chat_data: state.get('home').get('all_chat_data'),
        active_date: state.get('home').get('active_date'),
        active_topicid: state.get('home').get('active_topicid'),
        chat_count_data: state.get('home').get('chat_count_data'),
        is_show_screen_personal_overview: state.get('home').get('is_show_screen_personal_overview'),
        is_show_screen_stone_model_mall: state.get('home').get('is_show_screen_stone_model_mall'),
        is_show_screen_personal_backpack: state.get('home').get('is_show_screen_personal_backpack'),
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        handleIsThinkingAction(status) {
            dispatch(actionCreators.isThinkingAction(status))
        },
        handleIsFeedbackModalOpenAction(status) {
            dispatch(actionCreators.isFeedbackModalOpenAction(status))
        },
        handleMenuSearchContentAction(value) {
            dispatch(actionCreators.menuSearchContentAction(value))
        },
        handleUserinfoModalOpenAction() {
            dispatch(actionCreators.handleUserinfoModalOpenAction())
        },
        handleSwitchItemAction(active_date, active_topicid) {
            dispatch(actionCreators.switchItemAction(active_date, active_topicid))
        },
        handleIsShowScreenPersonalOverview(status) {
            dispatch(actionCreators.isShowScreenPersonalOverview(status))
        },
        handleIsShowScreenStoneModelMall(status) {
            dispatch(actionCreators.isShowScreenStoneModelMall(status))
        },
        handleIsShowScreenPersonalBackpack(status) {
            dispatch(actionCreators.isShowScreenPersonalBackpack(status))
        },
        handleExpertRelatedAction() {
            dispatch(actionCreators.expertRelatedAction())
        },
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChatMessageHeader))